import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
// import SampleLogo from "assets/images/logos/LogoZumi.png";
import { getImageUrl } from "api/ImageViewer";
import { getWebsite } from "api/configWebsiteAPI";
import Home from "@mui/icons-material/Home";
import { Box, Typography } from "@mui/material";
// import SampleLogo from "assets/images/logos/LogoZumi.png";
import "./Style.scss";
import { useColorTheme } from "../../context/ColorThemeContext";

function SignIn() {
  const colors = useColorTheme();
  const [headerData, setHeaderData] = useState({
    email: "",
    phone: "",
    logo: "",
    preview: "",
  });
  function resolvePreviewSrc(logo) {
    if (!logo) return "";
    if (typeof logo === "string") {
      return logo.startsWith("data:image") ? logo : getImageUrl(logo);
    }
    if (logo instanceof File) {
      return URL.createObjectURL(logo);
    }
    return "";
  }
  async function fetchConfig() {
    const data = await getWebsite();
    if (data) {
      try {
        const parsedHeader = JSON.parse(data.header);
        setHeaderData({
          email: parsedHeader?.email || "",
          phone: parsedHeader?.phone || "",
          preview: resolvePreviewSrc(parsedHeader?.logo),
          logo: parsedHeader?.logo || "",
        });
      } catch (err) {
        console.error("Lỗi parse JSON:", err);
      }
    }
  }
  useEffect(() => {
    fetchConfig();
  }, []);
  // State management
  useEffect(() => {
    // Lưu lại màu gốc để khôi phục sau nếu cần
    const wrapper = document.querySelector(".wrapper");
    const oldBg = wrapper?.getAttribute("style");

    if (wrapper) {
      wrapper.setAttribute("style", "background-color: white");
    }

    return () => {
      // Khôi phục lại khi rời trang login
      if (wrapper && oldBg !== null) {
        wrapper.setAttribute("style", oldBg);
      }
    };
  }, []);
  const navigate = useNavigate();
  return (
    <AppBar
      // position={navbarType}
      color="inherit"
      sx={{
        background: "#EFF0F2",
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.03)",
        marginBottom: "10px",
        maxHeight: "100px",
      }}
    >
      <Toolbar
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: colors.dashboardBackground || "#F2F4F7",
          px: 2,
        }}
      >
        {/* Trái: Nút menu */}
        <Box sx={{ flex: 1, display: "flex", alignItems: "center" }}>
          <IconButton
            size="small"
            color="inherit"
            // sx={navbarMobileMenu}
            // onClick={handleMiniSidenav}
          >
            {/* <Icon className="text-dark">{miniSidenav ? "menu_open" : "menu"}</Icon> */}
          </IconButton>
        </Box>

        {/* Giữa: Logo + Info trái/phải logo */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            maxWidth: { xs: "15%", sm: "auto" }, // Limit center width on xs
          }}
        >
          {/* BÊN TRÁI LOGO: Email + Phone */}
          <Box
            sx={{
              position: "absolute",
              right: "100%",
              marginRight: 2,
              display: "flex",
              flexDirection: { xs: "column", sm: "row" }, // xs: chia 2 dòng, sm+: cùng dòng
              alignItems: { xs: "flex-end", sm: "center" },
              gap: { xs: 0.5, sm: 2 },
              whiteSpace: "nowrap",
              textAlign: "right",
            }}
          >
            {/* Email */}
            <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
              <EmailIcon sx={{ fontSize: { xs: 12, sm: 14, md: 16 }, color: "#333" }} />
              <Typography
                component="a"
                href="mailto:Kinhdoanh@zumi.com.vn"
                sx={{
                  fontSize: { xs: 10, sm: 12, md: 14 },
                  fontWeight: 700,
                  color: "#333",
                  textDecoration: "none",
                  transition: "filter 0.3s ease, transform 0.3s ease",
                  "&:hover, &:focus": {
                    // filter: "brightness(1.2)",
                    transform: "scale(1.03)",
                    textDecoration: "none",
                  },
                }}
              >
                {headerData.email}
              </Typography>
            </Box>

            {/* Phone */}
            <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
              <PhoneIcon sx={{ fontSize: { xs: 10, sm: 12, md: 14 }, color: "#333" }} />
              <Typography
                component="a"
                href="tel:0903132585"
                sx={{
                  fontSize: { xs: 10, sm: 12, md: 14 },
                  fontWeight: 700,
                  color: "#333",
                  textDecoration: "none",
                  transition: "filter 0.3s ease, transform 0.3s ease",
                  "&:hover, &:focus": {
                    // filter: "brightness(1.2)",
                    transform: "scale(1.03)",
                    textDecoration: "none",
                  },
                }}
              >
                {headerData.phone}
              </Typography>
            </Box>
          </Box>

          {/* LOGO CHÍNH GIỮA */}
          <Box
            component="a"
            onClick={() => navigate("/")}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              width: { xs: 70, sm: 120 }, // Fixed width for the logo container
              maxWidth: { xs: 70, sm: 120 }, // Enforce maxWidth
              px: 0, // Remove padding to avoid extra width
              mt: { xs: 0, sm: 1, md: 2 },
              cursor: "pointer",
              transition: "filter 0.3s ease, transform 0.3s ease",
              "&:hover, &:focus": {
                filter: "brightness(1.2)",
                transform: "scale(1.03)",
              },
            }}
          >
            <Box
              component="img"
              src={headerData.preview}
              alt="Logo"
              sx={{
                height: { xs: 30, sm: 60, md: 80 },
                objectFit: "contain",
                maxWidth: { xs: 70, sm: "100%", md: "100%" },
              }}
            />
          </Box>

          {/* BÊN PHẢI LOGO: Đăng nhập */}
          <Box
            sx={{
              position: "absolute",
              left: "100%",
              marginLeft: { xs: 1, sm: 2 },
              display: "flex",
              alignItems: "center",
              gap: 1,
              whiteSpace: "nowrap",
              cursor: "pointer",
            }}
            onClick={() => navigate("/")}
          >
            <Home sx={{ fontSize: { xs: 14, sm: 18 }, color: "#0094FF" }} />
            <Typography
              variant="caption"
              sx={{
                fontSize: { xs: 12, sm: 14, md: "18px" },
                fontWeight: "bold",
                color: "#0094FF",
              }}
            >
              Trở về trang chủ
            </Typography>
          </Box>
        </Box>

        {/* Phải: trống để giữ logo luôn ở center */}
        <Box sx={{ flex: 1 }} />
      </Toolbar>
    </AppBar>
  );
}

export default SignIn;
